/**
 * @typedef {Object} ApiNotification
 * @property {number} recipientId
 * @property {number} notificationId
 * @property {string} title
 * @property {string} message
 * @property {string} notificationType
 * @property {number} [referenceId]
 * @property {string} [referenceType]
 * @property {string} [redirectUrl]
 * @property {string} createdAt
 * @property {string|null} [createdBy]
 * @property {boolean} isRead
 * @property {string|null} [readAt]
 */

/**
 * @typedef {Object} NotificationViewModel
 * @property {string} id
 * @property {number} recipientId
 * @property {number} notificationId
 * @property {string} title
 * @property {string} message
 * @property {boolean} read
 * @property {number} createdAt
 * @property {string} link
 * @property {string} [notificationType]
 * @property {number} [referenceId]
 * @property {string} [referenceType]
 * @property {string} [redirectUrl]
 */

export const NOTIFICATIONS_REFRESH_EVENT = "notifications-refresh";

export function dispatchNotificationsRefresh() {
  window.dispatchEvent(new CustomEvent(NOTIFICATIONS_REFRESH_EVENT));
}
